import css from './wordListItem.module.scss';

import { getEntries } from 'core/helpers/object';
import { prettifyText } from 'core/helpers/text';
import DisplayTemplate from 'core/ui/DisplayTemplate';
import LangIcon from 'core/ui/LangIcon';

export const Definitions = ({ def }: { def: TWord['definitions'] }) => (
  <>
    {getEntries<TLangAndNone, string | undefined>(def).map(([lang, text]) => (
      <TextRow key={lang} text={orDie(text)} lang={lang} />
    ))}
  </>
);

export const TextRow = ({
  text,
  lang,
}: {
  text: string;
  lang: TLangAndNone | null;
}) => (
  <div className={css.definitions} key={lang}>
    {!lang || lang === 'none' ? (
      <div className={css.langNoneIcon}>◯</div>
    ) : (
      <LangIcon className={css.langIcon} lang={lang} />
    )}{' '}
    <DisplayTemplate children={orDie(text)} />
  </div>
);

export const NoteRow = ({ text }: { text: string }) => (
  <div className={css.note}>{prettifyText(text)}</div>
);
